<template>
  <div class="b-table-container">
    <div class="flex-container">
      <slot name="external-search"></slot>
      <div class="search noprint" v-if="search_filter">
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            id="search-form"
            type="search"
            v-model="input_search"
            v-b-tooltip.v-secondary.noninteractive="
              $t('reusable.common.pressEnterToAddFilter')
            "
            :placeholder="$t('reusable.common.searchPlaceholder')"
            @keyup.enter="addSearchTag"
          >
          </b-form-input>
          <b-input-group-append>
            <b-button
              class="btn-search"
              variant="primary"
              :disabled="!input_search"
              :title="$t('reusable.common.search')"
              @click="addSearchTag"
            >
              <b-icon icon="search"></b-icon>
            </b-button>
          </b-input-group-append>
          <!-- <b-input-group-append>
            <b-button
              class="btn-clear"
              :disabled="!input_search"
              @click="input_search = ''"
              >{{ $t("reusable.common.clear") }}</b-button
            >
          </b-input-group-append> -->
        </b-input-group>
        <div class="tag-container mt-2">
          <div
            class="style-tag"
            v-for="(tag, index) in multiple_search"
            :key="index"
          >
            <div class="d-flex">
              <div class="align-self-center">
                {{ tag }}
              </div>
              <b-button
                class="p-0"
                variant="none"
                v-b-tooltip.v-secondary.noninteractive="
                  $t('reusable.common.removeFilter')
                "
                @click="deleteTag(index)"
              >
                <b-icon font-scale="1" style="color: white" icon="x"></b-icon>
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="columns-btn noprint">
        <div class="column-selector noprint" v-if="columns_display">
          <div class="d-flex">
            <VisibleColumns
              :id_button="`col-display-1-${display_id}`"
              :tooltip_text="''"
            >
              <template #popover-title>
                {{ $t("reusable.common.displayColumns") }}
              </template>
              <template #popover-content>
                <div
                  class="column-check noprint"
                  v-for="(field, index) in fields"
                  :key="index"
                >
                  <b-form-checkbox
                    v-if="field.label != ''"
                    :disabled="
                      (dynamicFields.length == 1 && field.display_column) ||
                      (dynamicFields[0].key == 'selected' &&
                        dynamicFields.length == 2 &&
                        field.display_column) ||
                      (dynamicFields[dynamicFields.length - 1].key ==
                        'actions' &&
                        dynamicFields.length == 2 &&
                        field.display_column)
                    "
                    :id="`column-check-${index}`"
                    v-model="field.display_column"
                    name="checkbox-1"
                  >
                    {{ field.label }}
                  </b-form-checkbox>
                </div>
              </template>
            </VisibleColumns>
            <!-- <b-button
              :id="`col-display-1-${display_id}`"
              class="col-display-1"
              variant="none"
              size="sm"
              >Visualizar columnas</b-button
            > -->
            <slot name="btn-download"></slot>
          </div>
          <!-- <b-popover
            :id="`columns-popover-1-${display_id}`"
            :target="`col-display-1-${display_id}`"
            placement="bottom"
            class="col-popover-1"
            triggers="click blur"
          >
            <div
              class="column-check noprint"
              v-for="(field, index) in fields"
              :key="index"
            >
              <b-form-checkbox
                v-if="field.label != ''"
                :disabled="
                  (dynamicFields.length == 1 && field.display_column) ||
                  (dynamicFields[0].key == 'selected' &&
                    dynamicFields.length == 2 &&
                    field.display_column) ||
                  (dynamicFields[dynamicFields.length - 1].key == 'actions' &&
                    dynamicFields.length == 2 &&
                    field.display_column)
                "
                :id="`column-check-${index}`"
                v-model="field.display_column"
                name="checkbox-1"
              >
                {{ field.label }}
              </b-form-checkbox>
            </div>
          </b-popover> -->
        </div>
        <div
          class="column-selector noprint"
          v-if="search_filter && view_filter_by"
        >
          <b-button
            :id="`col-display-2-${display_id}`"
            class="col-display-2"
            variant="none"
            size="sm"
            >{{ $t("reusable.common.filterBy") }}</b-button
          >
          <b-popover
            :id="`columns-popover-2-${display_id}`"
            :target="`col-display-2-${display_id}`"
            placement="bottom"
            custom-class="filteron-popover"
            bottom
            triggers="click blur"
          >
            <b-form-group
              v-model="sortDirection"
              label-size="sm"
              :description="$t('reusable.common.deselectAllToFilter')"
              class="mb-0 filter-by-column noprint"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-checkbox-group
                v-model="filterOn"
                :aria-describedby="ariaDescribedby"
                class="mt-1"
              >
                <div v-for="(field, index) in fields" :key="index">
                  <b-form-checkbox
                    v-if="field.label != ''"
                    :value="field.key"
                    class="check-filteron"
                    >{{ field.label }}</b-form-checkbox
                  >
                </div>
              </b-form-checkbox-group>
            </b-form-group>
          </b-popover>
        </div>
      </div>
    </div>
    <b-table
      id="generic-table"
      ref="genericTable"
      :busy="busy"
      class="generic-table"
      thead-class="b-card-style text-center"
      tfoot-class="custom-footer"
      :items="filterItem"
      :filter-included-fields="filterOn"
      :filter-function="filterCustom"
      :fields="dynamicFields"
      show-empty
      small
      bordered
      borderless
      responsive
      striped
      :selectable="selection_mode"
      :select-mode="select_mode"
      @row-selected="slotSelected"
      :empty-text="$t('reusable.common.noDataToShow')"
      :empty-filtered-text="$t('reusable.common.noMatchingData')"
      @sort-changed="handleSort"
      primary-key="id"
      :sort-by="sort_by"
      :sort-desc="sort_desc"
      :no-local-sorting="no_local_sorting"
    >
      <template #head()="{ label, field: { key, sortable } }">
        <div class="custom-th">
          {{ label }}
          <template v-if="sortable">
            <b-img
              v-if="sort_by !== key"
              :src="sortIconNeutral"
              class="sort-arrow"
            ></b-img>
            <b-img
              v-else-if="sort_desc"
              :src="sortIconAsc"
              class="sort-arrow"
            ></b-img>
            <b-img v-else :src="sortIconDesc" class="sort-arrow"></b-img>
          </template>
        </div>
      </template>
      <template #table-busy>
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </template>
      <template v-if="draggable_rows" #cell(drag_handle)>
        <b-icon
          icon="arrows-expand"
          class="drag-handle grabbable noprint"
        ></b-icon>
      </template>
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope" />
      </template>
      <template v-if="show_pagination" v-slot:custom-foot="row">
        <div class="footer-caption noprint" colspan="0">
          <i
            >{{ $t("reusable.common.showing") }}
            {{ row.items.length }}
            {{ $t("reusable.common.of") }} {{ items.count }}
            {{ $t("reusable.common.rowsTotal") }}</i
          >
        </div>
      </template>
    </b-table>
    <div class="pagination-bar d-flex mt-2 noprint">
      <div class="d-flex align-items-center">
        <span class="custom-span-pagination mr-1">
          {{ $t("reusable.common.perPage") }}
        </span>
        <b-form-select
          class="custom-input-pagination"
          id="per-page-input"
          v-model="per_page"
          size="sm"
          :options="per_page_options"
          @change="fetchData(1)"
          v-b-tooltip.v-secondary.noninteractive="
            $t('reusable.common.perPageTooltip')
          "
        ></b-form-select>
      </div>
      <div v-if="show_pagination" class="ml-auto">
        <b-pagination
          :key="current_page_key"
          v-model="current_page"
          :total-rows="items.count"
          :per-page="per_page"
          :disabled="per_page == items.count"
          @change="(value) => fetchData(value)"
          size="sm"
          class="my-0"
          no-title
        ></b-pagination>
      </div>
    </div>
    <!-- <b-row class="custom-row noprint">
      <b-col sm="5" md="6" class="per-page-col">
        <b-form-group
          label="Por página:"
          label-for="per-page-input"
          label-align-sm="right"
          label-size="sm"
          class="per-page-container"
        >
          <b-form-input
            id="per-page-input"
            v-model="per_page"
            size="sm"
            type="number"
            min="0"
            :max="items.count"
            @input="fetchData(1)"
            v-b-tooltip.v-secondary.noninteractive="
              'Cantidad de elementos que se van a mostrar por página.'
            "
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="7" md="6" class="my-1 noprint" v-if="show_pagination">
        <b-pagination
          :key="current_page_key"
          v-model="current_page"
          :total-rows="items.count"
          :per-page="per_page"
          :disabled="per_page == items.count"
          @change="(value) => fetchData(value)"
          align="fill"
          size="sm"
          class="my-0"
          no-title
        ></b-pagination>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import { generateUniqueId } from "@/utils/utils";
import Sortable from "sortablejs";

export default {
  name: "NewGenericBTable",
  components: {
    VisibleColumns: () =>
      import("@/components/reusable/Buttons/VisibleColumns"),
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Number,
      default: 10,
    },
    url: {
      type: String,
      required: true,
    },
    // Si se llegara a necesitar un prefiltro que este fuera del caso del djangoFilter.
    // como ejemplo se podria agregar 'type=1&order=2'
    pre_filter: {
      type: String,
      default: "",
    },
    // que se filtre si o si, ejmplo: ["Estudiante","Docente"]
    pre_required_search: {
      type: Array,
      default() {
        return [];
      },
    },
    // ["Estudiante","Docente"]
    pre_multiple_search: {
      type: Array,
      default() {
        return [];
      },
    },
    // ["action=CREATE", "created_at__date=2024-01-01"]
    pre_filter_tags: {
      type: Array,
      default() {
        return [];
      },
    },
    pre_input_search: {
      type: String,
      default: "",
    },
    show_pagination: {
      type: Boolean,
      default: true,
    },
    search_filter: {
      type: Boolean,
      default: true,
    },
    columns_display: {
      type: Boolean,
      default: true,
    },
    selection_mode: {
      type: Boolean,
      default: false,
    },
    //select_mode: single, multi, range
    select_mode: {
      type: String,
      default: "single",
    },
    // pre_page para definir la pag actual al cargar el componente.
    pre_current_page: { type: Number, default: 1 },
    // El orden lo decide siempre el servidor (&ordering=): un re-sort local de la
    // página ordenaría por el valor crudo de la celda (ids de relaciones) y
    // desarmaría el orden ya resuelto.
    no_local_sorting: {
      type: Boolean,
      default: true,
    },
    view_filter_by: {
      type: Boolean,
      default: false,
    },
    // Habilita reordenar filas por drag-and-drop (agrega una columna con handle).
    // El componente solo reordena lo que tiene cargado: si se usa junto con paginación,
    // el consumidor es responsable de pasar page_size/pagination suficiente para mostrar
    // todo el conjunto reordenable en una sola página (ej. pagination="100" + show_pagination=false).
    // Al soltar una fila emite @row-reorder con el array de items ya reordenado.
    draggable_rows: {
      type: Boolean,
      default: false,
    },
    filterCustom: {
      type: Function,
    },
    sortDesc: {},
    sortBy: {},
    Busy: {
      default: true,
    },
    display_id: {
      default: generateUniqueId(),
    },
  },
  data() {
    return {
      per_page: Number(this.pagination) || 10,
      items: { count: 0, next: null, previous: null, results: [] },
      busy: this.Busy,
      current_page: 1,
      current_page_key: 0,
      total_rows: 1,
      columns_selected: this.fields,
      table_items: [],
      multiple_search: [...this.pre_multiple_search],
      input_search: this.pre_input_search,
      filterOn: [],
      sort_desc: this.sortDesc,
      sort_by: this.sortBy,
      sortIconNeutral:
        "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
      sortIconDesc:
        "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
      sortIconAsc:
        "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e",
      sortable_instance: null,
    };
  },
  computed: {
    per_page_options() {
      const base = [10, 25, 50, 100];
      const current = Number(this.per_page);
      if (current && !base.includes(current)) {
        base.push(current);
        base.sort((a, b) => a - b);
      }
      return base;
    },
    filterItem() {
      return this.items.results;
    },
    // La columna se ordena por su propia clave, salvo que declare ordering_key con el
    // campo que entiende el backend (por ejemplo shift -> shift__name)
    orderingField() {
      if (!this.sort_by) return "";
      const field = this.fields.find((x) => x.key == this.sort_by);
      return (field && field.ordering_key) || this.sort_by;
    },
    // Parámetro de orden para la URL; vacío mientras no haya columna elegida
    orderingParam() {
      if (!this.sort_by) return "";
      return `&ordering=${this.sort_desc ? "-" : ""}${this.orderingField}`;
    },
    dynamicFields() {
      let fields = [];
      if (this.selection_mode) {
        fields.push({
          key: "selected",
          label: this.$t("reusable.common.selectLabel"),
          thStyle: { width: "1%" },
        });
      }

      fields = this.columns_selected.filter((field) => field.display_column);
      if (this.draggable_rows) {
        fields = [
          {
            key: "drag_handle",
            label: "",
            thStyle: { width: "1%" },
            tdClass: "text-center noprint",
          },
          ...fields,
        ];
      }
      return fields;
    },
  },
  methods: {
    slotSelected(rows) {
      this.$emit("selected", rows);
    },
    fetchGenericBTable() {
      let filters_url = "";
      if (this.pre_filter_tags.length > 0)
        filters_url = this.pre_filter_tags.map((tag) => `&${tag}`).join("");
      let partial_url = "";
      let pre_multiple_search = this.pre_multiple_search;
      if (this.pre_required_search.length > 0)
        pre_multiple_search = pre_multiple_search.concat(
          this.pre_required_search
        );
      if (pre_multiple_search.length > 0)
        partial_url = "&search=" + pre_multiple_search.join(",");
      this.$restful
        .Get(
          `${this.url}?${this.pre_filter}&page=${this.pre_current_page}&page_size=${parseInt(this.per_page)}${partial_url}${filters_url}${this.orderingParam}`
        )
        .then((response) => {
          this.current_page = this.pre_current_page;
          this.items = response;
          this.table_items = response.results;
          this.total_rows = response.results.length;
          this.busy = false;
          this.$emit("actual_items", response.results);
          this.$emit("total_items", response.count);
          this.$emit("response", response);
          this.current_page_key++;
          this.initSortable();
        });
    },
    fetchData(current_page = 1) {
      this.busy = true;
      this.current_page = current_page;
      let partial_url = "";
      let multiple_search = this.multiple_search;
      if (this.pre_required_search.length > 0)
        multiple_search = multiple_search.concat(this.pre_required_search);
      if (multiple_search.length > 0)
        partial_url = "&search=" + multiple_search.join(",");

      // Agregar pre_filter_tags como parámetros separados
      let filters_url = "";
      if (this.pre_filter_tags.length > 0)
        filters_url = this.pre_filter_tags.map((tag) => `&${tag}`).join("");
      const ordering = this.orderingParam;
      if (this.per_page == "" || this.per_page == null)
        return { count: 0, next: null, previous: null, results: [] };
      if (this.pre_filter != "") {
        this.$restful
          .Get(
            `${this.url}?${
              this.pre_filter
            }&page=${current_page}&page_size=${parseInt(
              this.per_page
            )}${partial_url}${filters_url}${ordering}`
          )
          .then((response) => {
            this.items = response;
            this.table_items = response.results;
            this.total_rows = response.results.length;
            this.busy = false;
            this.$emit("current_tag", this.multiple_search);
            this.$emit("actual_items", response.results);
            this.$emit("current_page", current_page);
            this.$emit("total_items", response.count);
            this.$emit("response", response);
            this.initSortable();
          });
      } else {
        this.$restful
          .Get(
            `${this.url}?page=${current_page}&page_size=${parseInt(
              this.per_page
            )}${partial_url}${filters_url}${ordering}`
          )
          .then((response) => {
            this.items = response;
            this.table_items = response.results;
            this.total_rows = response.results.length;
            this.busy = false;
            this.$emit("current_tag", this.multiple_search);
            this.$emit("actual_items", response.results);
            this.$emit("current_page", current_page);
            this.$emit("total_items", response.count);
            this.$emit("response", response);
            this.initSortable();
          });
      }
    },
    initSortable() {
      if (!this.draggable_rows) return;
      this.$nextTick(() => {
        const tbody =
          this.$refs.genericTable &&
          this.$refs.genericTable.$el.querySelector("tbody");
        if (!tbody) return;
        if (this.sortable_instance) this.sortable_instance.destroy();
        this.sortable_instance = Sortable.create(tbody, {
          handle: ".drag-handle",
          animation: 150,
          onEnd: (evt) => {
            if (evt.oldIndex === evt.newIndex) return;
            const moved = this.items.results.splice(evt.oldIndex, 1)[0];
            this.items.results.splice(evt.newIndex, 0, moved);
            this.$emit("row-reorder", this.items.results);
          },
        });
      });
    },
    addSearchTag() {
      if (this.input_search != "") this.multiple_search.push(this.input_search);
      this.input_search = "";
      this.current_page = 1;
      this.fetchData();
    },
    deleteTag(index) {
      this.multiple_search.splice(index, 1);
      this.current_page = 1;
      this.fetchData();
    },
    handleSort({ sortBy, sortDesc }) {
      this.sort_by = sortBy;
      this.sort_desc = sortDesc;
      this.fetchData(1); // Refrescar los datos con la nueva ordenación
    },
  },
  watch: {
    input_search(val) {
      this.$emit("input_search_changed", val);
    },
    pagination: function (n, o) {
      if (n == o || n < 0 || n > 20) return;
      this.per_page = n;
    },
    pre_multiple_search() {
      if (this.pre_multiple_search.length > 0) this.fetchData();
    },
    pre_filter_tags() {
      this.fetchData();
    },
    fields: {
      handler(newFields) {
        this.columns_selected = newFields;
      },
      deep: true,
    },
    filterOn: function (n, o) {
      if (n == o) return;
      this.$emit("emitChangeFilterOn", n);
    },
  },
  created() {
    this.fetchGenericBTable();
    // Escuchar los eventos de sort de la tabla
    this.$on("sort-changed", this.handleSort);
  },
  beforeDestroy() {
    if (this.sortable_instance) this.sortable_instance.destroy();
  },
};
</script>

<style scoped>
.tag-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
}
/* Tag de filtro: usa el estándar de chip sólido (ver .kl-chip en styles_kl.css) */
.style-tag {
  display: inline-flex;
  align-items: center;
  background-color: var(--kl-chip-solid-bg);
  color: var(--kl-chip-solid-text);
  max-width: fit-content;
  border-radius: var(--kl-chip-radius);
  margin: 0.1em;
  padding: var(--kl-chip-padding);
  font-size: var(--kl-chip-fs);
}
/* Buscador y botones de columnas siempre en la misma fila (en pantallas
   pequeñas el input se encoge en vez de empujar la tuerca a otra fila). */
.flex-container {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 1em;
}
.search {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
}
/* ----- Input de búsqueda según el estándar (--kl-input-*) ----- */
.search >>> .input-group-text {
  background: var(--kl-surface);
  border: 1px solid var(--kl-input-border);
  border-right: none;
  border-radius: var(--kl-input-radius) 0 0 var(--kl-input-radius);
  color: var(--kl-text-muted);
}
.search >>> #search-form {
  border: 1px solid var(--kl-input-border);
  border-left: none;
  border-radius: 0 var(--kl-input-radius) var(--kl-input-radius) 0 !important;
  font-size: var(--kl-input-fs);
  color: var(--kl-text-body);
}
.search >>> #search-form:focus {
  border-color: var(--kl-input-border-focus);
  box-shadow: var(--kl-shadow-focus);
}
/* ----- Botones Buscar / Limpiar según el estándar (--kl-btn-*) ----- */
.btn-search {
  color: var(--kl-btn-text) !important;
  border: none !important;
  border-radius: var(--kl-btn-radius) !important;
  font-size: var(--kl-btn-fs);
  font-weight: var(--kl-btn-fw);
  margin-left: 8px;
  transition: background 0.2s ease;
}
/* .btn-clear {
  background: var(--kl-surface) !important;
  color: var(--kl-text-body) !important;
  border: 1px solid var(--kl-border) !important;
  border-radius: var(--kl-btn-radius) !important;
  font-size: var(--kl-btn-fs);
  font-weight: var(--kl-btn-fw);
  transition: background 0.2s ease;
}
.btn-clear:hover:not(:disabled) {
  background: var(--kl-surface-hover) !important;
} */
.col-display-1,
.col-display-2 {
  min-width: 154px;
  margin-left: 2em;
  background-color: var(--kl-color-primary) !important;
  color: var(--kl-text-on-primary);
  border-radius: var(--kl-btn-radius) !important;
  font-size: var(--kl-btn-fs);
  font-weight: var(--kl-btn-fw);
  border: none;
  /* Misma altura que la tuerca (VisibleColumns) y el input de búsqueda */
  height: var(--kl-input-height);
}
.col-display-1:hover,
.col-display-2:hover {
  background-color: var(--kl-color-primary-hover) !important;
  transition: all 0.3s;
}
.col-popover-1 {
  z-index: 1010 !important;
}
.column-selector {
  width: auto;
  margin-left: 0em;
}
.column-check {
  text-align: left;
}
.filter-by-column {
  width: 100%;
}
.filter-on-check {
  width: 300px;
}
.filteron-popover {
  width: 170px;
}
.custom-control-inline {
  margin-right: 0;
}
.custom-th {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.custom-row {
  margin-bottom: 1rem;
}
.b-table-container {
  margin: 1rem;
}
/* Encabezado de tablas: celeste claro con texto azul (estilo dashboard) */
.b-table-container >>> .b-card-style th {
  background: var(--kl-table-header-bg) !important;
  color: var(--kl-table-header-text) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-table-header-fs);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 11px 12px !important;
  border: none !important;
  vertical-align: middle;
  white-space: normal;
}
/* ----- Barra de paginación según el estándar (styles_kl.css) ----- */
.pagination-bar {
  align-items: center;
  gap: 8px;
}
.pagination-bar >>> .pagination {
  margin-bottom: 0;
}
.pagination-bar >>> .page-item {
  margin-left: 4px;
}
/* Indicadores de página tipo píldora */
.pagination-bar >>> .page-link {
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-radius-md) !important;
  background: var(--kl-surface);
  color: var(--kl-text-body);
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.pagination-bar >>> .page-link:hover {
  background: var(--kl-surface-hover);
  color: var(--kl-color-primary);
  border-color: var(--kl-color-accent-border);
}
.pagination-bar >>> .page-link:focus {
  box-shadow: var(--kl-shadow-focus);
}
.pagination-bar >>> .page-item.active .page-link {
  background: var(--kl-color-primary);
  border-color: var(--kl-color-primary);
  color: var(--kl-text-on-primary);
}
.pagination-bar >>> .page-item.disabled .page-link {
  background: var(--kl-surface-muted);
  color: var(--kl-text-muted);
  border-color: var(--kl-border-soft);
}
.per-page-container {
  display: flex;
}
.custom-span-pagination {
  min-width: 90px;
  color: var(--kl-text-muted);
  font-size: var(--kl-fs-small);
  font-weight: var(--kl-fw-semibold);
  white-space: nowrap;
}
/* Input "Por página" según el estándar (--kl-input-*) */
.custom-input-pagination {
  margin: 0px !important;
  width: 64px;
  height: 32px;
  text-align: center;
  font-size: var(--kl-fs-small);
  color: var(--kl-text-body);
  border: 1px solid var(--kl-input-border);
  border-radius: var(--kl-input-radius) !important;
}
.custom-input-pagination:focus {
  border-color: var(--kl-input-border-focus);
  box-shadow: var(--kl-shadow-focus);
}
.per-page-col {
  margin-top: 0.4rem;
  max-width: 320px;
}
.per-page-input-append {
  margin-top: 8%;
  max-width: 300px;
  font-size: 11pt;
}
.footer-caption {
  color: var(--kl-text-muted);
  font-size: var(--kl-fs-small);
  padding-top: 0;
  float: left;
  transform: translateX(10%);
  margin-right: -200px;
}
.b-table-container >>> .custom-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 100% !important;
}
.columns-btn {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-left: auto;
  flex-shrink: 0;
}
.popover {
  z-index: 10 !important;
}
.sort-arrow {
  width: 0.5rem;
  height: 0.9rem;
  margin-left: 4px;
  transform: none;
}
.drag-handle.grabbable {
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
.drag-handle.grabbable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
#search-form {
  min-height: var(--kl-input-height);
}
/* ----- Estilo visual unificado (igual a las tablas del dashboard) ----- */
/* Contenedor con esquinas redondeadas y borde suave */
.b-table-container >>> .table-responsive {
  border-radius: var(--kl-table-radius);
  border: 1px solid var(--kl-table-border);
}
.b-table-container >>> .generic-table {
  margin-bottom: 0;
}
/* Celdas del cuerpo */
.b-table-container >>> .generic-table tbody td {
  color: var(--kl-table-text);
  font-size: var(--kl-table-fs);
  padding: 11px 12px !important;
  border: none !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
  vertical-align: middle;
}
/* Filas: blancas por defecto, alternadas en celeste muy claro + hover.
El td pinta por encima del striped de Bootstrap, así que controla el color. */
.b-table-container >>> .generic-table tbody tr > td {
  background-color: var(--kl-table-row-bg);
}
.b-table-container >>> .generic-table tbody tr:nth-child(even) > td {
  background-color: var(--kl-table-row-alt-bg);
}
.b-table-container >>> .generic-table tbody tr:hover > td {
  background-color: var(--kl-table-row-hover-bg);
}
/* Conserva el resaltado de fila seleccionada (modo selección) */
.b-table-container >>> .generic-table tbody tr.b-table-row-selected > td {
  background-color: var(--kl-table-row-selected-bg) !important;
}
@media (max-width: 991px) {
  /* Se mantiene todo en una fila: el input se encoge y los botones de
     columnas se compactan en vez de bajar a una segunda fila. */
  .column-selector {
    margin-left: 0;
    width: auto;
  }
  .col-display-1,
  .col-display-2 {
    min-width: 0;
    margin: 0;
    width: auto;
    white-space: nowrap;
  }
  .filteron-popover {
    width: 180px !important;
    margin: 0;
  }
  .filter-by-column {
    width: auto !important;
  }
  i {
    margin-right: auto;
  }
}
/* Css para ocultar imagen de sorting por defecto en b-table */
.b-table-container >>> .table.b-table > thead > tr > [aria-sort="none"],
.b-table-container >>> .table.b-table > thead > tr > [aria-sort="ascending"],
.b-table-container >>> .table.b-table > thead > tr > [aria-sort="descending"] {
  background-image: none !important;
}
</style>